import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCodelines = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.25 18.5C10.6642 18.5 11 18.8358 11 19.25C11 19.6642 10.6642 20 10.25 20H2.75C2.33579 20 2 19.6642 2 19.25C2 18.8358 2.33579 18.5 2.75 18.5H10.25ZM21.25 18.5C21.6642 18.5 22 18.8358 22 19.25C22 19.6642 21.6642 20 21.25 20H14.75C14.3358 20 14 19.6642 14 19.25C14 18.8358 14.3358 18.5 14.75 18.5H21.25ZM8.25 11.25C8.66421 11.25 9 11.5858 9 12C9 12.4142 8.66421 12.75 8.25 12.75H2.75C2.33579 12.75 2 12.4142 2 12C2 11.5858 2.33579 11.25 2.75 11.25H8.25ZM21.25 11.25C21.6642 11.25 22 11.5858 22 12C22 12.4142 21.6642 12.75 21.25 12.75H12.75C12.3358 12.75 12 12.4142 12 12C12 11.5858 12.3358 11.25 12.75 11.25H21.25ZM13.2002 4C13.6143 4.00011 13.9502 4.33585 13.9502 4.75C13.9502 5.16415 13.6143 5.49989 13.2002 5.5H2.75C2.33579 5.5 2 5.16421 2 4.75C2 4.33579 2.33579 4 2.75 4H13.2002ZM21.25 4C21.6642 4 22 4.33579 22 4.75C22 5.16421 21.6642 5.5 21.25 5.5H17.75C17.3358 5.5 17 5.16421 17 4.75C17 4.33579 17.3358 4 17.75 4H21.25Z",
		fill: "currentColor"
	})]
});
export default SvgCodelines;
